"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.FULL_WIDTH_ACTION_BUTTON_BREAKPOINT = void 0;
function cov_mdmjiu580() {
  var path = "/codebuild/output/src975848493/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/ProductList/lib/constants.js";
  var hash = "d95ffeb6b0de0f30f444a160475af496fc08d7af";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src975848493/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/ProductList/lib/constants.js",
    statementMap: {
      "0": {
        start: {
          line: 2,
          column: 51
        },
        end: {
          line: 2,
          column: 52
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "d95ffeb6b0de0f30f444a160475af496fc08d7af"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_mdmjiu580 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_mdmjiu580();
/* eslint-disable import/prefer-default-export */
var FULL_WIDTH_ACTION_BUTTON_BREAKPOINT = exports.FULL_WIDTH_ACTION_BUTTON_BREAKPOINT = (cov_mdmjiu580().s[0]++, 3);